import React from 'react';

import { ClockProps } from './types';

const Clock = ({
  className,
  color = '#161616',
  onClick,
}: ClockProps): JSX.Element => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    className={className}
    onClick={onClick}
  >
    <title>Clock icon</title>
    <g clipPath="url(#clockClipPath)">
      <path
        d="M7.33335 4.27774V8.49996C7.33335 8.86815 7.63183 9.16662 8.00002 9.16662H10.5926M8.00002 15.8333C3.94993 15.8333 0.666687 12.55 0.666687 8.49996C0.666687 4.44987 3.94993 1.16663 8.00002 1.16663C12.0501 1.16663 15.3334 4.44987 15.3334 8.49996C15.3334 12.55 12.0501 15.8333 8.00002 15.8333Z"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clockClipPath">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Clock;
